var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vus-panel"},[_c('div',{staticClass:"vus-panel-heading"},[_c('h3',{staticClass:"vus-panel-title"},[_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"vus-panel-body"},[_c('p',[_vm._t("content")],2)])])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/vus-panle/vus-panel.vue